<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { AGENCY_ORIGINS as ORIGENS } from 'dashboard/helper/lais/agencyOrigins';

const form = defineModel({
  type: Object,
  required: true,
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Canais de origem aceitos">
    <p class="text-[13px] text-lais-text-muted mb-4">
      Selecione quais portais e canais a Lais deve atender. Clientes que chegam
      por origens não selecionadas ficam pausados.
    </p>
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <label
        v-for="o in ORIGENS"
        :key="o.value"
        class="flex items-center gap-3 p-3 border rounded-lais cursor-pointer transition-colors"
        :class="
          form.origens_aceitas.includes(o.value)
            ? 'border-lais-primary bg-[#f0e8fa]/40'
            : 'border-[#e5e7eb] hover:border-lais-primary/40'
        "
      >
        <input
          v-model="form.origens_aceitas"
          type="checkbox"
          :value="o.value"
          class="size-4 accent-lais-primary shrink-0"
        />
        <span
          class="size-2.5 rounded-full shrink-0"
          :style="{ backgroundColor: o.color }"
        />
        <span class="text-[13px] font-medium text-lais-text">{{
          o.label
        }}</span>
      </label>
    </div>
  </LaisCard>
</template>
